import { updateUserInfo } from '@/api';

function checkOS() {
	const IorA = navigator.userAgent.toLowerCase();

	if (IorA.indexOf('android') !== -1) {
		// android 일 때
		return 'A';
	} else if (IorA.indexOf('iphone') !== -1) {
		// iphone 일 때
		return 'I';
	} else {
		return null;
	}
}

export function sendToID(userId) {
	/**
	 * 개발자도구 Device Mode에서도 osType이 인식 되므로
	 * 웹에서 로그인 시도 할 때는, Device Mode 풀고 로그인하기
	 */
	const osType = checkOS();
	// 아이폰
	if (osType === 'I') {
		try {
			let str = '';

			if (userId) {
				let info = { userid: userId };
				str = JSON.stringify(info);
			}

			window.webkit.messageHandlers.loginInfo.postMessage(str);
		} catch (error) {
			console.error('iOS bridge error:', error);
		}
	}
	// 안드로이드
	if (osType === 'A') {
		try {
			window.himo.callbackHandler(userId);
		} catch (error) {
			console.error('Android bridge error:', error);
		}
	}
}

export function callbackUserIdToken(json) {
	const info = JSON.parse(json);
	updateUserInfo(info);
}
